
const Inputs =[

  [
    {
      type: 'password',
      name: 'password',
      placeholder: { ar: "ادخل كلمة المرور الجديدة", en:  "New password" },
      loginBool: "true"

    },
    
    {
      type: 'password',
      name: 'newPassword',
      placeholder: {ar: "تاكيد كلمة المرور الجديدة" ,en:"confirm New Password" },
      loginBool: "true"


    }
  ]


]

export default Inputs;
